export const CheckboxFilter = ({config, onChange, value}) => (
    <div className="mb-1">
        <label className="flex items-center gap-3 p-1 cursor-pointer hover:bg-base-50 rounded transition-colors group">
            <input
                type="checkbox"
                className="checkbox checkbox-primary checkbox-sm rounded-md border-base-300"
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span
                className={`text-sm font-medium ${value ? 'pt-dark-blue' : 'text-base-content/70'} transition-colors`}>
                {config.label}
            </span>
        </label>
    </div>
);